/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "appApi",
            "endpoint": "https://fjvnf7ohn9.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "publicApi",
            "endpoint": "https://867fstuz6b.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:0c0bff35-bb5d-4a73-a24a-8f35635e8fd7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Hkj1X2mXI",
    "aws_user_pools_web_client_id": "2vckti1qcm5puued8k7f07fdfu",
    "oauth": {
        "domain": "primaryrecord52ec7167-52ec7167-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "primary-record-app://,exp://127.0.0.1:8081/--/,https://www.primaryrecord.app/,https://dev.primaryrecord.app/,http://localhost:19006",
        "redirectSignOut": "exp://127.0.0.1:8081/--/,primary-record-app://,https://www.primaryrecord.app/,https://dev.primaryrecord.app/,http://localhost:19006",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "ABACRuleSets-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "AuditLogComments-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "AuditLogs-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "CareTeamMemberRelationships-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "CareTeamMembers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "ChatMessages-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "ContactDetails-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "EmailEntitySentInvites-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "FastenConnections-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "FastenEvents-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "FastenRefreshProgress-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileCollaboratorInvites-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileCollaborators-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileConfiguredResourceInviteEmails-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileDirectives-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileFileArtifacts-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileFileFolders-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileFiles-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileIdCards-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileInsuranceCards-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileOwnershipTransfers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileRefreshProgress-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfileUsageMetrics-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "MedicalProfiles-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "NoteComments-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "Notes-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OneUpHealthSystemConnections-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OneUpHealthUsers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationClientInvitations-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationClientRecords-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationGroupClientRecords-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationGroupUsers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationGroups-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationInvitationDefinitions-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationStripeAccounts-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationUsageMetrics-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationUserInvitations-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "OrganizationUsers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "Organizations-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "PDFMonkeyProcessingRecord-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "RecurringTasks-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "RegistrationCodes-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "ResourceCareTeamMembers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "ResourceRecords-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "ResourceRelationships-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "ScheduledJobs-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "SearchState-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "SharedReportViews-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "SharedReports-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "StripeCustomers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "UnreadInAppNotifications-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "UserDevicePushTokens-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "UserIdLookup-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "UserMedicalProfileChats-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "UserPreferences-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "UserProducts-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "UserRegistrationCodes-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "UserSettings-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "UserSubLookupCache-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "Users-dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
